export { default } from "bullitttime-embermodelsevent/adapters/tie-timing-record";
